module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lacerta/lac_vis-dd17867ceb12f645c586225be3975134.jpg";